/**
 * Acesso às telas restritas (RestrictedRoute). Ninguém abre tela restrita sem permissão: `temAcesso` e `temPermissao`
 * só respondem pelos registros do usuário logado (os dele e os do perfil dele), que o PermissoesProvider busca e entrega
 * às telas (`usePermissoes`). O admin tem bypass de tudo: a API devolve a ele `todas`. O localStorage guarda o que veio
 * por último, para a primeira tela não esperar a API.
 */
const CHAVE = 'acessoPermissoes';

// Os códigos que o código confere (`permissao.codigo` no banco), para os botões:
// `permissoes.temPermissao(PERMISSOES.FLUXO_AEREO)`. Na tela de Permissões de Acesso são o select de código da regra;
// a API valida contra `Permissao::CODIGOS`, que espelha esta lista: código novo entra nos dois.
export const PERMISSOES = {
    FLUXO_AEREO: 'fluxoAereo',
    // Rafael 23/10: aprovar o câmbio do fornecedor pago no exterior no Efetivo (Tati e Vanessa).
    APROVAR_CAMBIO_INTER: 'aprovarCambioInter',
};

// As telas restritas, `{ rota, nome, grupo }`, registradas pelo routes.js a partir das `ROTAS_RESTRITAS`: o path base,
// que é o que se compara, e o nome e o grupo da tela, que a tela de Permissões de Acesso mostra.
let rotasRestritas = [];
export const registrarRotasRestritas = (rotas) => { rotasRestritas = rotas; };
export const listarRotasRestritas = () => rotasRestritas;

export const lerPermissoes = () => {
    try { return JSON.parse(localStorage.getItem(CHAVE)); } catch (e) { return null; }
};

export const salvarPermissoes = (dados) => {
    try { localStorage.setItem(CHAVE, JSON.stringify(dados)); } catch (e) { /* sem storage */ }
};

export const limparPermissoes = () => {
    try { localStorage.removeItem(CHAVE); } catch (e) { /* sem storage */ }
};

// O `to` do Link, string ou objeto, sem a query. Casa a rota e o que vem depois de uma barra, como as listas de perfil
// da PrivateRoute: `/aereo` não pega `/aereoFaturaCvc`.
const caminhoDe = (to) => String(to?.pathname ?? to ?? '').split(/[?#]/)[0];
const casa = (caminho, rota) => caminho === rota || caminho.startsWith(rota + '/');

/** A rota é de uma tela restrita? Para as listas que misturam telas restritas e comuns (menus, atalhos). */
export const ehRestrita = (to) => rotasRestritas.some(t => casa(caminhoDe(to), t.rota));

/** Alguma regra do usuário abre a rota? */
export const temAcesso = (to, permissoes) => !!permissoes?.todas
    || (permissoes?.rotas ?? []).some(rota => casa(caminhoDe(to), rota));

/** O usuário tem a regra? Para o botão que não leva a uma rota. */
export const temPermissao = (codigo, permissoes) => !!permissoes?.todas || (permissoes?.codigos ?? []).includes(codigo);
